import React from 'react'
import './Hww.css'

function Hww() {

    const hwwline = [
        {
            number: "1",
            desc: "DISCUSSION"
        },
        {
            number: "2",
            desc: "CREATIVE CONCEPT"
        },
        {
            number: "3",
            desc: "PRODUCTION"
        },
        {
            number: "4",
            desc: "HAPPY CLIENT"
        }
    ]

  return (
    <section className='Hww-sec'>
        <div className='container'>
            <div className='mn-head'> 
              <h5>How we work</h5>
              <h3>At 360Bytes we are specialized in brand strategy and digital creation</h3>
            </div>
            <ul>
                {
                  hwwline.map((Hww, index)=>(
                    <li key={index}>
                        <h4>{Hww.number}</h4>
                        <p>{Hww.desc}</p>
                    </li>
                  ))  
                }
                
            </ul>
        </div>
    </section>
  )
}

export default Hww
